// extracted by mini-css-extract-plugin
export default {"root":"tbINr","header":"uIISt","headerSwitch":"ylhbU","inner":"GXFfv","upload":"dUawF"};